import type { ObjectDirective } from 'vue'

type InterpolationElement = HTMLElement & {
  $componentUpdated?: () => void
  $destroy?: () => void
}

export const vInterpolate: ObjectDirective<InterpolationElement> = {
  mounted (el) {
    const links = el.getElementsByTagName('a')
    const internalLinks: HTMLAnchorElement[] = []
    Array.from(links).forEach((linkEl) => {
      const href = linkEl.getAttribute('href')
      if (!href) {
        return false
      }

      if (isInternalLink(href)) {
        internalLinks.push(linkEl)
      } else {
        linkEl.setAttribute('target', '_blank')
      }
    })

    addListeners(internalLinks)
    // cleanup
    el.$componentUpdated = () => {
      removeListeners(internalLinks)
      nextTick(() => addListeners(internalLinks))
    }
    el.$destroy = () => removeListeners(internalLinks)
  },
  updated: el => el.$componentUpdated?.(),
  beforeUnmount: el => el.$destroy?.()
}

function navigate (event: Event) {
  const target = event.target as HTMLElement
  let link
  if (target.tagName === 'A') {
    link = target as HTMLAnchorElement
  } else {
    link = target.closest('a') as HTMLAnchorElement
  }
  const href = link.getAttribute('href')

  event.preventDefault()
  return navigateTo(href)
}

function addListeners (links: HTMLAnchorElement[]) {
  links.forEach((link) => {
    link.addEventListener('click', navigate, false)
  })
}

function removeListeners (links: HTMLAnchorElement[]) {
  links.forEach((link) => {
    link.removeEventListener('click', navigate, false)
  })
}

function isInternalLink (href?: string) {
  return href?.startsWith('/')
}
